module.exports = __webpack_public_path__ + "static/commerce2x-elasticsearch-8035d7c6908a43582229f4a40a11413b.png";